import React from 'react'

const NoDataAvailableCard = ({ title = "", subtext = "" }) => {
  return (
    <div className="no-data-card">
      <svg
        width="48"
        height="48"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.5l5-5 4 4 5-6 4 3" />
        <rect x="3" y="3" width="18" height="18" rx="2" strokeLinecap="round" />
      </svg>
      <p className="no-data-title">{title}</p>
      <p className="no-data-subtext">{subtext}</p>
    </div>
  )
}

export default NoDataAvailableCard
